import Footer from '../components/Footer';
import bgimage from '../images/groupimage2.jpeg'

const partnerLogos = [
  { id: 1, src: "/Agra.svg", alt: "AGRA" },
  { id: 2, src: "/lfg.svg", alt: "LFG" },
  { id: 3, src: "/ug.svg", alt: "University of Ghana" },
];

const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 grid grid-cols-1 lg:grid-cols-2">
        {/* Left Branding Panel */}
        <div
          className="hidden lg:flex relative bg-cover bg-center"
          style={{
            backgroundImage: `url(${bgimage})`,
          }}
        >
          <div className="absolute inset-0 bg-black/20" />
          <div className="relative z-10 flex flex-col justify-between p-10 text-white">
            <h1 className="text-2xl font-semibold">
              EYES Ghana Program
            </h1>

            <p className="text-lg max-w-md">
              Empowering Youth for Excellence & Success in Ghana's food and
              agriculture sector.
            </p>
          </div>
        </div>

        {/* Right Form Panel */}
        <div className="flex flex-col px-6 py-8">
          <div className="flex items-center justify-center space-x-10 gap-10 mb-8">
            {partnerLogos.map((logo) => (
              <img
                key={logo.id}
                src={logo.src}
                alt={logo.alt}
                className="h-12 w-auto object-contain"
              />
            ))}
          </div>
          
          {/* Form Content */}
          <div className="flex-1 flex items-center justify-center">
            <div className="w-full max-w-md">
              {children}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AuthLayout;
